import { addDays, addHours, addMinutes, addYears, endOfDay, endOfMonth, endOfWeek, endOfYear, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays, subHours, subMinutes, subMonths, subWeeks, subYears, } from 'date-fns';
export { format, toDate, startOfDay, startOfWeek, startOfMonth, startOfYear, endOfDay, endOfWeek, endOfMonth, endOfYear, addDays, addHours, addYears, isSameDay, subDays, subHours, subWeeks, subMonths, subYears, } from 'date-fns';
export function yearsAgo(date, amount = 0) {
    return subYears(date, amount);
}
export function yearsInFuture(date, amount = 0) {
    return addYears(date, amount);
}
export function startOfYearsAgo(date, amount = 0) {
    return startOfYear(yearsAgo(date, amount));
}
export function endOfYearsAgo(date, amount = 0) {
    return endOfYear(yearsAgo(date, amount));
}
export function minutesAgo(date, amount = 0) {
    return subMinutes(date, amount);
}
export function minutesInFuture(date, amount = 0) {
    return addMinutes(date, amount);
}
export function daysInFuture(date, amount = 0) {
    return addDays(date, amount);
}
export function hoursInFuture(date, amount = 0) {
    return addHours(date, amount);
}
export function hoursAgo(date, amount) {
    return subHours(date, amount);
}
export function daysAgo(date, amount = 0) {
    return subDays(date, amount);
}
export function startOfDaysAgo(date, amount = 0) {
    return startOfDay(daysAgo(date, amount));
}
export function endofDaysAgo(date, amount = 0) {
    return endOfDay(daysAgo(date, amount));
}
export function weeksAgo(date, amount = 0) {
    return subWeeks(date, amount);
}
export function startOfWeeksAgo(date, weeks = 0) {
    return startOfWeek(weeksAgo(date, weeks));
}
export function endOfWeeksAgo(date, weeks = 0) {
    return endOfWeek(weeksAgo(date, weeks));
}
export function monthsAgo(date, amount = 0) {
    return subMonths(date, amount);
}
export function startOfMonthsAgo(date, months = 0) {
    return startOfMonth(monthsAgo(date, months));
}
export function endOfMonthsAgo(date, months = 0) {
    return endOfMonth(monthsAgo(date, months));
}
